var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8125 2H2.9375C2.62684 2 2.375 2.25184 2.375 2.5625V13.4375C2.375 13.7482 2.62684 14 2.9375 14H14.8125C15.1232 14 15.375 13.7482 15.375 13.4375V2.5625C15.375 2.25184 15.1232 2 14.8125 2ZM2.9375 0C1.52227 0 0.375 1.14727 0.375 2.5625V13.4375C0.375 14.8527 1.52227 16 2.9375 16H14.8125C16.2277 16 17.375 14.8527 17.375 13.4375V2.5625C17.375 1.14727 16.2277 0 14.8125 0H2.9375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9375 8.71484C9.76593 8.71484 10.4375 8.04327 10.4375 7.21484C10.4375 6.38642 9.76593 5.71484 8.9375 5.71484C8.10907 5.71484 7.4375 6.38642 7.4375 7.21484C7.4375 8.04327 8.10907 8.71484 8.9375 8.71484ZM8.9375 10.7148C10.8705 10.7148 12.4375 9.14784 12.4375 7.21484C12.4375 5.28185 10.8705 3.71484 8.9375 3.71484C7.0045 3.71484 5.4375 5.28185 5.4375 7.21484C5.4375 9.14784 7.0045 10.7148 8.9375 10.7148Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4375 12.7148L5.4375 6.71484H7.4375L7.4375 12.7148H5.4375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 15C8.98978 15 9.4375 15.4477 9.4375 16V22C9.4375 22.5523 8.98978 23 8.4375 23C7.88522 23 7.4375 22.5523 7.4375 22L7.4375 16C7.4375 15.4477 7.88522 15 8.4375 15Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBookings);
export default __webpack_public_path__ + "static/media/ico_bookings.bd0928da95d83cbe1548d5c59fa94639.svg";
export { ForwardRef as ReactComponent };